<template>
  <div class="pt-8 px-2 px-sm-8 px-lg-16">
    <StoreProfile
        v-if="storeProfile"
        :storeProfile="storeProfile"
        :nftContract="storeInfo.nftContract"
        :storeAccount="storeAccount"
        class="mb-4"
    ></StoreProfile>

    <v-row class="mb-8">
      <v-col class="col-lg-4 d-lg-block d-none">
        <CustomerProfile
            :storeAccount="storeAccount"
            :customerAccount="customerAccount"
        ></CustomerProfile>
      </v-col>
      <v-col class="col-12 col-lg-8">
        <StoreInfo
            v-if="storeInfo"
            :store-info="storeInfo"
        ></StoreInfo>
        <CustomerProfile
            :storeAccount="storeAccount"
            :customerAccount="customerAccount"
            class="d-block mt-4 d-lg-none"
        ></CustomerProfile>
        <div class="mt-4">
<!--          <v-btn class="my-4" color="primary darken-2" dark block>-->
<!--            <div class="d-flex align-center">-->
<!--              <span>Store Proposals</span>-->
<!--              <v-icon size="16" class="ml-1">mdi-logout-variant</v-icon>-->
<!--            </div>-->
<!--          </v-btn>-->
          <v-tabs
              fixed-tabs
              background-color="indigo darken-3"
              dark
              v-model="tab"
          >
            <v-tab href="#purchasable">
              For Sell
            </v-tab>
            <v-tab href="#redeemable">
              Redeemable
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item
                value="purchasable"
                class="background"
            >
              <PurchasableList
                  :storeAccount="storeAccount"
                  ref="purchasableList"
              >
                <template v-slot:topRightBtn="purchasable">
                  <v-btn
                      color="indigo darken-3"
                      dark
                      @click="buyHandle(purchasable)"
                  >
                    Buy
                  </v-btn>
                </template>
              </PurchasableList>
            </v-tab-item>
            <v-tab-item
                value="redeemable"
                class="background"
            >
              <RedeemableList
                  :storeAccount="storeAccount"
                  ref="redeemableList"
              >
                <template v-slot:topRightBtn="{redeemable, itemsPerPage, page, index}">
                  <v-btn
                      color="indigo darken-3"
                      dark
                      :loading="redeemLoading[(page-1) * itemsPerPage + index]"
                      @click="redeemHandle(redeemable, itemsPerPage, page, index)"
                  >
                    Redeem
                  </v-btn>
                </template>
              </RedeemableList>
            </v-tab-item>
          </v-tabs-items>

          <ProposalList
              :storeAccount="storeAccount"
              :editable="true"
              class="mt-8"
          >
            <template v-slot:voteConfirm="{proposalData, selectedOption}">
              <v-btn
                  :loading="votingLoading[proposalData.proposalId]"
                  small
                  block
                  class="mt-2"
                  outlined
                  color="indigo darken-2"
                  @click="vote(proposalData.proposalId, selectedOption)"
              >
                Vote
              </v-btn>
            </template>
          </ProposalList>
        </div>
      </v-col>
    </v-row>
    <PaymentDialog
        v-if="paymentDialogShow"
        :storeAccount="storeAccount"
        :paymentAmount="(selectedPurchasable.price / (10 ** paymentCoinDecimal)).toString()"
        :purchasableId="selectedPurchasable.purchasableId"
    >
      <template v-slot:paymentInfo="{storeAccount, paymentAmount, purchasableId}">
        <v-card color="grey lighten-3">
          <v-card-text>
            <div>Store Account : {{storeAccount}}</div>
            <div>Payment Amount : {{paymentAmount}}</div>
            <div>Purchasable Id : {{purchasableId}}</div>
          </v-card-text>
        </v-card>
      </template>
    </PaymentDialog>
  </div>
</template>

<script>
import StoreProfile from "@/components/StoreProfile";
import StoreInfo from "@/components/StoreInfo";
import store from "@/store";
import StoreProfileInfoMixin from "@/mixins/StoreProfileInfoMixin";
import CustomerProfile from "@/views/Store/Component/CustomerProfile";
import PurchasableList from "@/components/PurchasableList/PurchasableList";
import RedeemableList from "@/components/RedeemableList/RedeemableList";
import PaymentDialog from "@/components/PaymentDialog";
import ProposalList from "@/components/ProposalList/ProposalList";
import config from "@/config";
import ethCall from "@/lib/eth/ethCall";
import ethUtil from "@/lib/eth/util";
import Vue from "vue";
export default {
  name: "Store",
  mixins: [StoreProfileInfoMixin],
  components: {
    PaymentDialog,
    CustomerProfile,
    StoreProfile,
    StoreInfo,
    PurchasableList,
    RedeemableList,
    ProposalList
  },
  computed: {
    paymentDialogShow() {
      return store.state.paymentDialogShow
    }
  },
  async mounted() {
    store.state.pageLoading = true
    await this.getStoreInfoAndProfile(this.storeAccount)
    store.state.pageLoading = false
  },
  data() {
    return {
      storeAccount: this.$route.query.storeAccount,
      customerAccount: store.state.loggedInAccount,
      tab: null,
      selectedPurchasable: null,
      redeemLoading: [],
      votingLoading: [],
      paymentCoinDecimal: config.commonConfig.paymentCoinDecimal
    }
  },
  methods: {
    async buyHandle(purchasable) {
      this.selectedPurchasable = purchasable
      store.state.paymentDialogShow = true
    },
    async redeemHandle(redeemable, itemsPerPage, page, index) {
      this.$set(this.redeemLoading, (page - 1) * itemsPerPage + index, true)
      try {
        await ethCall.storeFactory.redeem(this.storeAccount, parseInt(redeemable.redeemableId), 1)
        Vue.notify({
          type: "success",
          text: `Success to redeem item`
        })
      }catch (e) {
        const revertMsg = ethUtil.errorMsgHandle(e.message)
        if (revertMsg) {
          Vue.notify({
            type: "error",
            text: revertMsg
          })
        }
      }finally {
        this.$set(this.redeemLoading, (page - 1) * itemsPerPage + index, false)
      }
    },
    async vote(proposalId, option) {
      try {
        this.$set(this.votingLoading, proposalId, true)
        await ethCall.proposalFactory.vote(this.storeAccount, proposalId, option)
        Vue.notify({
          type: "success",
          text: `Success to vote`
        })
      }catch (e) {
        const revertMsg = ethUtil.errorMsgHandle(e.message)
        if (revertMsg) {
          Vue.notify({
            type: "error",
            text: revertMsg
          })
        }
      }finally {
        this.$set(this.votingLoading, proposalId, false)
      }
    }
  }
}
</script>

<style scoped>

</style>